import { render, staticRenderFns } from "./PatientDocumentListView.vue?vue&type=template&id=15f645fb&scoped=true&"
import script from "./PatientDocumentListView.vue?vue&type=script&lang=ts&"
export * from "./PatientDocumentListView.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDocumentListView.vue?vue&type=style&index=0&id=15f645fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f645fb",
  null
  
)

export default component.exports